import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { vgField } from '../../fielddef';
import { fieldExpr } from '../../timeunit';
import { duplicate, hash as _hash, keys, vals } from '../../util';
import { DataFlowNode } from './dataflow';
export var TimeUnitNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(TimeUnitNode, _DataFlowNode);

  function TimeUnitNode(parent, formula) {
    var _this;

    _classCallCheck(this, TimeUnitNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeUnitNode).call(this, parent));
    _this.formula = formula;
    return _this;
  }

  _createClass(TimeUnitNode, [{
    key: "clone",
    value: function clone() {
      return new TimeUnitNode(null, duplicate(this.formula));
    }
  }, {
    key: "merge",
    value: function merge(other) {
      this.formula = Object.assign({}, this.formula, other.formula);
      other.remove();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.as;
      }));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.field;
      }));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "TimeUnit ".concat(_hash(this.formula));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return vals(this.formula).map(function (c) {
        return {
          type: 'formula',
          as: c.as,
          expr: fieldExpr(c.timeUnit, c.field)
        };
      });
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var formula = model.reduceFieldDef(function (timeUnitComponent, fieldDef) {
        if (fieldDef.timeUnit) {
          var f = vgField(fieldDef, {
            forAs: true
          });
          timeUnitComponent[f] = {
            as: f,
            timeUnit: fieldDef.timeUnit,
            field: fieldDef.field
          };
        }

        return timeUnitComponent;
      }, {});

      if (keys(formula).length === 0) {
        return null;
      }

      return new TimeUnitNode(parent, formula);
    }
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t) {
      return new TimeUnitNode(parent, _defineProperty({}, t.field, {
        as: t.as,
        timeUnit: t.timeUnit,
        field: t.field
      }));
    }
  }]);

  return TimeUnitNode;
}(DataFlowNode);